import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../assets/logo.jpg';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-white text-gray-800 shadow-sm border-b border-gray-200">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src={logoImage} 
              alt="Robin Hood Roma Logo" 
              className="h-10 w-auto mr-3 rounded-sm"
            />
            <span className="text-xl font-bold tracking-tight text-orange-600">Robin Hood Roma ODV</span>
          </Link>

          {/* Hamburger menu button for mobile */}
          <button
            className="lg:hidden focus:outline-none"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              {isMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex lg:items-center lg:space-x-6">
            <Link to="/" className="py-2 text-gray-700 hover:text-orange-600 transition-colors">
              Home
            </Link>
            <Link to="/chi-siamo" className="py-2 text-gray-700 hover:text-orange-600 transition-colors">
              Chi Siamo
            </Link>
            <Link to="/malattie-rare" className="py-2 text-gray-700 hover:text-orange-600 transition-colors">
              Malattie Rare
            </Link>
            <Link to="/eventi" className="py-2 text-gray-700 hover:text-orange-600 transition-colors">
              Eventi
            </Link>
            <Link to="/partners" className="py-2 text-gray-700 hover:text-orange-600 transition-colors">
              Partners
            </Link>
            <Link to="/consiglio-direttivo" className="py-2 text-gray-700 hover:text-orange-600 transition-colors">
              Attività
            </Link>
            <Link to="/sostienici" className="py-2 px-4 bg-red-600 text-white rounded-md font-bold text-base uppercase hover:bg-red-700 transition-colors">
              SOSTIENICI E DONA!
            </Link>
            <Link to="/contatti" className="py-2 text-gray-700 hover:text-orange-600 transition-colors">
              Contatti
            </Link>
          </nav>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden pb-4">
            <div className="flex flex-col space-y-2">
              <Link
                to="/"
                className="py-2 hover:bg-gray-100 px-3 rounded transition-colors"
                onClick={toggleMenu}
              >
                Home
              </Link>
              <Link
                to="/chi-siamo"
                className="py-2 hover:bg-gray-100 px-3 rounded transition-colors"
                onClick={toggleMenu}
              >
                Chi Siamo
              </Link>
              <Link
                to="/malattie-rare"
                className="py-2 hover:bg-gray-100 px-3 rounded transition-colors"
                onClick={toggleMenu}
              >
                Malattie Rare
              </Link>
              <Link
                to="/eventi"
                className="py-2 hover:bg-gray-100 px-3 rounded transition-colors"
                onClick={toggleMenu}
              >
                Eventi
              </Link>
              <Link
                to="/partners"
                className="py-2 hover:bg-gray-100 px-3 rounded transition-colors"
                onClick={toggleMenu}
              >
                Partners
              </Link>
              <Link
                to="/consiglio-direttivo"
                className="py-2 hover:bg-gray-100 px-3 rounded transition-colors"
                onClick={toggleMenu}
              >
                Consiglio Direttivo
              </Link>
              <Link
                to="/sostienici"
                className="py-2 px-3 bg-red-600 text-white rounded-md font-bold text-base uppercase hover:bg-red-700 transition-colors"
                onClick={toggleMenu}
              >
                SOSTIENICI E DONA!
              </Link>
              <Link
                to="/contatti"
                className="py-2 hover:bg-gray-100 px-3 rounded transition-colors"
                onClick={toggleMenu}
              >
                Contatti
              </Link>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;

